import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const GET_REVIEW = `${API_URL}/review`
export const GET_REVIEW_STATUS = `${API_URL}/review-status`

export const service = {
  getReviewAndRating: (params: ParamsModel) => {
    return axios.get(GET_REVIEW, {params})
  },
  getReviewStatus: () => {
    return axios.get(GET_REVIEW_STATUS)
  },

  //export file
  exportReviewFile: (fileName: string, params: ParamsModel) => {
    return axios.get(`${GET_REVIEW}/export`, {params}).then((response) => {
      const blob = new Blob([response?.data])
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${fileName}.csv`) //or any other extension
      document.body.appendChild(link)
      link.click()
    })
  },
}
